module.exports = __webpack_public_path__ + "img/frame (70).18fc5504.jpg";